import React from 'react';
import { ArrowRight, Star, Shield, Clock, ThumbsUp, CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CTASection } from '../components/CTASection';
import { CouponSection } from '../components/CouponSection';
export function HomePage() {
  return <div className="flex flex-col w-full" data-id="element-306" data-mp="3kpjylfza14ro">
      {/* Hero Section with Real Image Background */}
      <section className="relative py-24 sm:py-32 overflow-hidden" data-id="element-307" data-mp="2wzzbqm005nd4">
        {/* Background Image */}
        <div className="absolute inset-0 z-0" style={{
        backgroundImage: 'url("https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?auto=format&fit=crop&q=80")',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      }} data-id="element-308" data-mp="2s1xs9zynzm14" />
        {/* Dark overlay to ensure text readability while keeping it bright */}
        <div className="absolute inset-0 bg-[#0c2340]/70 z-0" data-id="element-309" data-mp="29bg66e8c7ooq" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0c2340] to-transparent z-0 opacity-80" data-id="element-310" data-mp="298tv44m8mr1r" />

        <div className="relative max-w-7xl mx-auto px-4 text-center z-10" data-id="element-311" data-mp="2an25u5r2vvzc">
          <span className="inline-block py-1.5 px-4 rounded-full bg-white/10 backdrop-blur-sm text-white font-semibold text-sm mb-6 border border-white/20 shadow-sm" data-id="element-312" data-mp="2eonibpzpa890">
            Serving Orange County, CA
          </span>
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-tight mb-6 max-w-4xl mx-auto leading-tight drop-shadow-lg" data-id="element-313" data-mp="2oi4a6oga1da1">
            Protect Your Home With{' '}
            <span className="text-[#b87333]" data-id="element-314" data-mp="1vtffp89q8679">Seamless Gutters</span>
          </h1>
          <p className="text-lg sm:text-xl text-slate-200 max-w-2xl mx-auto mb-10 drop-shadow-md" data-id="element-315" data-mp="20ss3bv8f9haw">
            Professional installation, repair, and maintenance of premium
            aluminum and copper rain gutters for residential and commercial
            properties.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-316" data-mp="3h3467x2m62eo">
            <Link to="/appointment" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#b87333] hover:bg-[#a0632a] text-white font-bold py-4 px-8 rounded-lg transition-colors shadow-xl shadow-[#b87333]/30" data-id="element-317" data-mp="2rf8i8rl6518p">
              Get a Free Estimate
              <ArrowRight className="w-5 h-5" data-id="element-318" data-mp="2wgo3okr9d9rm" />
            </Link>
            <Link to="/services" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 backdrop-blur-md text-white border-2 border-white/50 hover:border-white font-bold py-4 px-8 rounded-lg transition-all" data-id="element-319" data-mp="28pilw01rc7eo">
              View Our Services
            </Link>
          </div>
        </div>
      </section>

      {/* Trust Banner - Brightened */}
      <section className="bg-white py-12 border-b border-sky-100 shadow-sm relative z-20 -mt-8 mx-4 sm:mx-8 lg:mx-auto max-w-7xl rounded-2xl" data-id="element-320" data-mp="1pxzny7mlbjji">
        <div className="px-4" data-id="element-321" data-mp="iyoprpaixwe">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-322" data-mp="hx1kov02kyb">
            <div className="flex flex-col items-center" data-id="element-323" data-mp="59ouh61mp2rm">
              <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center mb-3" data-id="element-324" data-mp="5bhzkgwlfexi">
                <Shield className="w-6 h-6 text-[#0c2340]" data-id="element-325" data-mp="3mo2dpcl4kdb9" />
              </div>
              <h3 className="font-bold text-slate-900" data-id="element-326" data-mp="3rp9j54zsp0er">Licensed & Insured</h3>
              <p className="text-sm text-slate-500" data-id="element-327" data-mp="jahq5u3o23wb">Full protection</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-328" data-mp="o785gf7ncvgo">
              <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center mb-3" data-id="element-329" data-mp="a8iab54e15uy">
                <Star className="w-6 h-6 text-[#b87333]" data-id="element-330" data-mp="ea3gk7mf2lw6" />
              </div>
              <h3 className="font-bold text-slate-900" data-id="element-331" data-mp="ec6h3ll73xf5">5-Star Rated</h3>
              <p className="text-sm text-slate-500" data-id="element-332" data-mp="2uxxs5almpk8g">By local homeowners</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-333" data-mp="2z13zklkh9hgi">
              <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center mb-3" data-id="element-334" data-mp="3f775jhulw38j">
                <Clock className="w-6 h-6 text-[#0c2340]" data-id="element-335" data-mp="3ah0ivnjnmssx" />
              </div>
              <h3 className="font-bold text-slate-900" data-id="element-336" data-mp="3aexiqaosfjah">Fast Service</h3>
              <p className="text-sm text-slate-500" data-id="element-337" data-mp="35i77c0nxhbve">Quick turnaround</p>
            </div>
            <div className="flex flex-col items-center" data-id="element-338" data-mp="30jvxhpxmv1d6">
              <div className="w-12 h-12 bg-sky-50 rounded-full flex items-center justify-center mb-3" data-id="element-339" data-mp="20p0nwjw6awk">
                <ThumbsUp className="w-6 h-6 text-[#b87333]" data-id="element-340" data-mp="3t6qe2brbxgld" />
              </div>
              <h3 className="font-bold text-slate-900" data-id="element-341" data-mp="3o85aq3gs6gsp">100% Guarantee</h3>
              <p className="text-sm text-slate-500" data-id="element-342" data-mp="3oa8b9hfk7sbo">Satisfaction promised</p>
            </div>
          </div>
        </div>
      </section>

      {/* Services Overview with Images */}
      <section className="py-24 px-4 bg-slate-50" data-id="element-343" data-mp="2cujmqlmnql8r">
        <div className="max-w-7xl mx-auto" data-id="element-344" data-mp="28rmz2gi9fyxy">
          <div className="text-center mb-16" data-id="element-345" data-mp="28ptst2bk7gqh">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0c2340] mb-4" data-id="element-346" data-mp="o9m90kd3ww66">
              Expert Gutter Solutions
            </h2>
            <div className="w-24 h-1 bg-[#b87333] mx-auto rounded-full mb-6" data-id="element-347" data-mp="sbzd74c7gm0u" />
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-348" data-mp="x9ir234zqws9">
              We offer comprehensive rain gutter services to keep your property
              safe from water damage year-round.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-349" data-mp="16z2e7kzqlcsx">
            {[{
            title: 'Seamless Installation',
            desc: 'Custom-fit aluminum and copper gutters fabricated on-site for a perfect, leak-proof fit.',
            img: 'https://images.unsplash.com/photo-1513694203232-719a280e022f?auto=format&fit=crop&q=80&w=600'
          }, {
            title: 'Gutter Guards',
            desc: 'Premium leaf protection systems to keep debris out and water flowing freely.',
            img: 'https://images.unsplash.com/photo-1515694346937-94d85e41e6f0?auto=format&fit=crop&q=80&w=600'
          }, {
            title: 'Repairs & Maintenance',
            desc: 'Expert fixes for leaks, sagging, and damage to extend the life of your gutters.',
            img: 'https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1?auto=format&fit=crop&q=80&w=600'
          }].map((service, i) => <div key={i} className="bg-white rounded-2xl overflow-hidden border border-slate-200 hover:shadow-xl transition-all group flex flex-col" data-id="element-350" data-mp="1ct9a5tnrn8k9" data-mpi={i}>
                <div className="h-48 overflow-hidden relative" data-id="element-351" data-mp="1lprz6usvmcbk">
                  <div className="absolute inset-0 bg-[#0c2340]/20 group-hover:bg-transparent transition-colors z-10" data-id="element-352" data-mp="1hndjgjki7soi" />
                  <img src={service.img} alt={service.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-353" data-mp="1vm4shrkieo5s" />
                </div>
                <div className="p-8 flex-grow flex flex-col" data-id="element-354" data-mp="2f7wxfeynl9ko">
                  <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-355" data-mp="2f5aqnhjl6y3i">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 mb-6 flex-grow" data-id="element-356" data-mp="258xvsgcb2e76">
                    {service.desc}
                  </p>
                  <Link to="/services" className="text-[#b87333] font-semibold flex items-center gap-2 hover:text-[#0c2340] transition-colors mt-auto" data-id="element-357" data-mp="1rhapdnonfpao">
                    Learn more <ArrowRight className="w-4 h-4" data-id="element-358" data-mp="1hlpsg3yftf7s" />
                  </Link>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Lead Magnet / Coupon Section */}
      <CouponSection data-id="element-359" data-mp="18lkne0gpusws" />

      {/* Testimonials - Brightened */}
      <section className="py-24 px-4 bg-white" data-id="element-360" data-mp="1cka8kf7zxeqz">
        <div className="max-w-7xl mx-auto" data-id="element-361" data-mp="1t017uppetv9o">
          <div className="text-center mb-16" data-id="element-362" data-mp="1syzycpo1lgu2">
            <h2 className="text-3xl sm:text-4xl font-bold text-[#0c2340] mb-4" data-id="element-363" data-mp="1o183pnw0jgm6">
              What Our Customers Say
            </h2>
            <div className="w-24 h-1 bg-[#b87333] mx-auto rounded-full mb-6" data-id="element-364" data-mp="1j1bxrj3r9f3z" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-365" data-mp="1e3tmvn66gptc">
            {[{
            name: 'Sarah M.',
            loc: 'Irvine, CA',
            text: 'A-Flow did an amazing job replacing our old gutters. The copper looks beautiful and the crew was incredibly professional.'
          }, {
            name: 'David T.',
            loc: 'Anaheim, CA',
            text: "Got the leaf guards installed before the rainy season. Best decision ever. Haven't had to climb a ladder since!"
          }, {
            name: 'Michael R.',
            loc: 'Newport Beach, CA',
            text: 'Fast, affordable, and high quality. They fabricated everything right in my driveway. Highly recommend their services.'
          }].map((review, i) => <div key={i} className="bg-sky-50/50 p-8 rounded-2xl border border-sky-100 relative" data-id="element-366" data-mp="322nnm84jrgza" data-mpi={i}>
                <div className="flex gap-1 mb-4 text-[#b87333]" data-id="element-367" data-mp="3bxxtj6y2g8ic">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-5 h-5 fill-current" data-id="element-368" data-mp="2ecth08atmonh" data-mpi={j} />)}
                </div>
                <p className="text-slate-700 italic mb-6" data-id="element-369" data-mp="2jal50r8chqme">"{review.text}"</p>
                <div className="flex items-center gap-3" data-id="element-370" data-mp="2o8mpnglf5xzz">
                  <div className="w-10 h-10 bg-[#0c2340] rounded-full flex items-center justify-center text-white font-bold" data-id="element-371" data-mp="2szuzgdqnvldo">
                    {review.name.charAt(0)}
                  </div>
                  <div data-id="element-372" data-mp="20jtx7u40a8a4">
                    <h4 className="font-bold text-slate-900" data-id="element-373" data-mp="20j22smm5aglf">{review.name}</h4>
                    <p className="text-sm text-slate-500" data-id="element-374" data-mp="2bqwewo7qebcu">{review.loc}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      <CTASection data-id="element-375" data-mp="2lp3im5d0ewww" />
    </div>;
}